import TodoItem from "@/domain/entities/TodoItem";
import { CustomViewTodoItemDTO } from "@cs_teamwaydev/mailvista-sdk_react";

const customViewTodoMapper = (todo: CustomViewTodoItemDTO): TodoItem =>
    new TodoItem({
        id: todo.id,
        taskSummary: todo.taskSummary,
        linkedEventId: todo.linkedEventId,
        done: todo.done,
        isUserAccepted: todo.isUserAccepted,
        internetMessageId: todo.internetMessageId,
    });

export default customViewTodoMapper;
